var _defs, _path, _path2, _path3, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureLogicApps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a26",
    x1: 5.05,
    y1: 10.55,
    x2: 5.05,
    y2: 13.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76bc2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e9624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b26",
    x1: 12.84,
    y1: 10.57,
    x2: 12.84,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76bc2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e9624"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.19 15.6a2.49 2.49 0 01-1.53-.38 1.7 1.7 0 01-.45-1.36v-3.53c0-.58-.23-.89-.71-.89v-.88c.48 0 .71-.31.71-.92V4.17a1.79 1.79 0 01.45-1.39 2.29 2.29 0 011.53-.38v.89c-.51 0-.79.27-.79.85v3.4c0 .78-.23 1.26-.74 1.46a1.42 1.42 0 01.74 1.46v3.37a1.25 1.25 0 00.17.68.74.74 0 00.58.2v.89zM14.81 2.4a2.49 2.49 0 011.53.38 1.7 1.7 0 01.45 1.36v3.53c0 .58.23.89.71.89v.88c-.48 0-.71.31-.71.92v3.43a1.8 1.8 0 01-.45 1.4 2.28 2.28 0 01-1.53.41v-.89c.51 0 .79-.27.79-.85v-3.4c0-.78.23-1.26.74-1.46a1.42 1.42 0 01-.74-1.46V4.17a1.25 1.25 0 00-.17-.68.74.74 0 00-.58-.2z",
    fill: "#949494"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41 8.35V7.08h-.9v1.27a.18.18 0 01-.18.18H5a.36.36 0 00-.36.36v1.65h.9v-.91a.18.18 0 01.17-.18h6.54a.18.18 0 01.18.18v.93h.89V8.89a.36.36 0 00-.35-.36H9.59a.18.18 0 01-.18-.18z",
    fill: "#005ba1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.61 3.21H7.25a.38.38 0 00-.38.37v3.36a.37.37 0 00.38.37h3.36a.37.37 0 00.39-.37V3.58a.38.38 0 00-.39-.37zm-.32 3.17a.25.25 0 01-.25.24H7.81a.25.25 0 01-.25-.24V4.15a.25.25 0 01.25-.25H10a.25.25 0 01.25.25z",
    fill: "#0078d4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.58,
    y: 10.55,
    width: 2.94,
    height: 2.94,
    rx: 0.27,
    fill: "url(#a)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.38,
    y: 10.57,
    width: 2.94,
    height: 2.94,
    rx: 0.27,
    fill: "url(#b)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureLogicApps);
export default __webpack_public_path__ + "static/media/azure-logicApps.dc67b5941149c2c390a5a3375ac6520e.svg";
export { ForwardRef as ReactComponent };